import { useEffect, useState } from 'react';
import { AgrementsType } from '../use-agrements/types';
import { fetchPublishedAgreement } from './actions';
import { IPublishedAgreement, PublishedAgreementReturnType } from './types';

// Varianta publicată a unui acord (Termeni și condiții / Confidențialitate /
// GDPR-Cookies), pentru paginile legale publice. Eroarea se raportează inline
// (nu prin notify) — paginile sunt accesibile și neautentificat.
export function usePublishedAgreement(type: AgrementsType): PublishedAgreementReturnType {
	const [data, setData] = useState<IPublishedAgreement | null>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<boolean>(false);

	useEffect(() => {
		let active = true;
		setLoading(true);
		setError(false);
		fetchPublishedAgreement(type)
			.then((response) => {
				if (active) setData(response);
			})
			.catch(() => {
				if (active) setError(true);
			})
			.finally(() => {
				if (active) setLoading(false);
			});

		return () => {
			active = false;
		};
	}, [type]);

	return { data, loading, error };
}
